import React, {useEffect, useState} from 'react'
import useAppleMaps from '@hooks/useAppleMaps'
import useRef from '@hooks/useRef'
import useInitialData from '@page-components/Layout/useInitialData'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'

import getAnnotations from './getAnnotations'
import useDriverLocation from './useDriverLocation.main'
import useSmoothLocation from './useSmoothLocation'

export default function Map() {
  const mapkit = useAppleMaps()
  const {order} = useOrder()
  const {website} = useInitialData()
  const [mapLoaded, setMapLoaded] = useState(false)
  const map = useRef(null)

  // Uncomment to test location by clicking on the map
  // const driverLocationOriginal = useTestDriverLocation(map?.current, mapLoaded) || {
  const driverLocationOriginal = useDriverLocation() || {
    lat: null,
    lng: null
  }

  // Smooth location is used to make the driver location change frame by frame between the two points returned by the API.
  const {smoothLocation: driverLocation, isFinal} = useSmoothLocation(driverLocationOriginal)

  const [forceShortRange, setForceShortRange] = useState(false)

  const {lat, lng} = driverLocation

  useEffect(() => {
    map.current = new mapkit.Map('tracking-map')
    setMapLoaded(true)
  }, [])

  useEffect(() => {
    if (!map.current) return

    const annotations = getAnnotations(
      mapkit,
      order,
      website,
      driverLocation,
      driverLocationOriginal,
      {forceShortRange},
      overlays => {
        if (map.current.overlays) {
          map.current.removeOverlays(map.current.overlays)
        }
        map.current.addOverlays(overlays)
      }
    )

    if (annotations.type === 'shortRange') {
      // If we are already on short range, prevent going back to long range.
      setForceShortRange(true)
    }

    if (map.current.overlays && annotations.overlays?.length) {
      map.current.removeOverlays(map.current.overlays)
    }

    map.current.annotations = annotations.annotations

    const items = [...map.current.annotations, annotations.overlays]
    if (items.length === 0) {
      return
    }

    // showItems centers the map around the annotations and overlays.
    // We only want to shift the map after the driver movement animation has completed.
    if (annotations.type === 'longRange' || isFinal) {
      map.current.showItems(items, {
        animate: true,
        padding: new mapkit.Padding(60, 40, 60, 40)
      })
    }
  }, [lat, lng, forceShortRange, isFinal])

  return <div className="h-80 lg:h-full" id="tracking-map" />
}
